import $ from 'jquery';

$(document).ready(() => {
  // browser window scroll (in pixels) after which the "back to top" link is shown
  const offset = 300;

  // duration of the top scrolling animation (in ms)
  const scrollTopDuration = 700;

  // grab the "back to top" link
  const $backToTop = $('.to-top-link');

  // smooth scroll to top
  $backToTop.on('click', (event) => {
    event.preventDefault();

    $('body,html').animate(
      {
        scrollTop: 0,
      },
      scrollTopDuration,
    );
  });

  $(window).on('scroll', () => {
    $backToTop.toggleClass('is--sticky', $(window).scrollTop() > offset);
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/totoplink.js